import React from "react";
import './style.css';
import SVGFill from "../../asset/img/svg/svg-fill-fx";
import DetectDevice from "../../utils/detectDevice";

const Section4 = () => {
  const {mobile} = DetectDevice();
  const [fS, setFS] = React.useState(3);
  const [paddingVal, setPaddingVal] = React.useState(200);
  const [paddingValTop, setPaddingValTop] = React.useState(200);
  const [paddingValBtm, setPaddingValBtm] = React.useState(100);
  const [width, setWidth] = React.useState(540);
  const headingRef = React.useRef(null);
  const cardRef1 = React.useRef(null);
  const cardRef2 = React.useRef(null);
  const getRandomValue = (min, max) => Math.random() * (max - min) + min;

  React.useEffect(() => {
    mobile ? setFS(2) : setFS(5);
    mobile ? setPaddingVal(100) : setPaddingVal(200);
    mobile ? setPaddingValTop(100) : setPaddingValTop(200);
    mobile ? setPaddingValBtm(40) : setPaddingValBtm(100);
    mobile ? setWidth(330) : setWidth(540);
  }, [mobile]);
  
  // Position Effect
  React.useEffect(() => {
    const applyPositionEffect = (element, frequency, amplitude) => {
      const updatePosition = () => {
        const posX = Math.sin(Date.now() / frequency) * amplitude;
        const posY = Math.cos(Date.now() / frequency) * amplitude;
        element.style.transform = `translate(${posX}px, ${posY}px)`;
      };

      const interval = setInterval(updatePosition, 16); // About 60 FPS
      return () => clearInterval(interval); // Cleanup on unmount
    };

    // Apply position effect with random frequency and amplitude for each card
    const cleanupPosition1 = applyPositionEffect(
      cardRef1.current,
      getRandomValue(400, 600), 
      getRandomValue(1, 6)     
    );
    const cleanupPosition2 = applyPositionEffect(
      cardRef2.current,
      getRandomValue(400, 600),
      getRandomValue(1, 6)
    );

    // Clean up intervals on unmount
    return () => {
      cleanupPosition1();
      cleanupPosition2();
    };
  }, []);

  // Rotation Effect
  React.useEffect(() => {
    const applyRotationEffect = (element, frequency, amplitude) => {
      const updateRotation = () => {
        const rotation = Math.sin(Date.now() / frequency) * amplitude;
        element.style.transform += ` rotate(${rotation}deg)`;
      };

      const interval = setInterval(updateRotation, 16); // About 60 FPS
      return () => clearInterval(interval); // Cleanup on unmount
    };

    // Apply rotation effect with random frequency and amplitude for each card
    const cleanupRotation1 = applyRotationEffect(
      cardRef1.current,
      getRandomValue(600, 700), // Frequency range
      getRandomValue(0.5, 1.2)  // Lower amplitude range for subtle rotation
    );
    const cleanupRotation2 = applyRotationEffect(
      cardRef2.current,
      getRandomValue(600, 700),
      getRandomValue(0.5, 1.2)
    );    

    // Clean up intervals on unmount
    return () => {
      cleanupRotation1();
      cleanupRotation2();
    };
  }, []);

  return (
    <>
      <div className="section-4 d-flex flex-column align-items-center">
        <div className="col-12 col-lg-8 text-center z-3 heading-container"
          ref={headingRef}
          style={{
            marginTop: paddingValTop,
            marginBottom: paddingValBtm,
            fontSize: `${fS}rem`,         
            }}>          
          <div className="fw-bold heading px-lg-0 px-2">
            What makes SAVE unique?
          </div>
        </div>
        <div className="design-1 d-flex flex-lg-row flex-column justify-content-center gap-4 z-3">
          <div className="col-12 col-lg-6 card py-3 py-lg-5 px-3 px-lg-5 flex-row shadow-lg"
            ref={cardRef1} style={{marginTop: paddingVal, width: width}}>
            {/* <div className="line"/> */}
            <div className="flex-column z-3">
              <div className="p-3 icon-wrapper ">
                <i className="bi bi-briefcase px-4 py-3"/>
              </div>
              <div className="py-2"/>
              <div className="fs-1 card-title">Empowering businesses with proactive cyber<span>security</span> solutions</div>
              <div className="py-1 py-lg-2"/>
              <div className="card-text">A forward-thinking approach to protecting your data and ensuring compliance.</div>
            </div>
          </div>
          <div className="col-12 col-lg-6 card py-3 py-lg-5 px-3 px-lg-5 flex-row shadow-lg"
            ref={cardRef2} style={{marginTop: paddingVal, width: width}}>
            {/* <div className="line"/> */}
            <div className="flex-column">
              <div className="p-3 icon-wrapper">
                <i className="bi bi-shield-check px-4 py-3"></i>
              </div>
              <div className="py-2"/>
              <div className="fs-1 card-title">Driving innovation to stay ahead of evolving digital thr<span>e</span>ats </div>
              <div className="py-1 py-lg-2"/>
              <div className="card-text">Combining responsibility with technology for sustainable security.</div>
            </div>
          </div>
        </div>
        <div className="design-2 d-flex flex-column justify-content-center gap-4 py-5 z-3"
          style={{marginTop: paddingValTop - 100}}>
          <div className="card">
            <div className="card-body px-4">
              <div className="card-title">Cloud based solution</div>
              {/* <div className="card-text">Consumed through SAVE cloud</div> */}
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="card-title">Gets data feeds via APIs</div>
              {/* <div className="card-text">API accsess to security information in view-only mode</div> */}
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="card-title">Compatible with leading platforms</div>
              {/* <div className="card-text">API accsess to security information in view-only mode</div> */}
            </div>
          </div>
        </div>
        <div className="w-100 position-absolute"
          style={{marginTop: paddingValTop - (mobile? 20 : 30)}}>
          <SVGFill/>
        </div>
      </div>
    </>
  );
};

export default Section4;

